/**
 * Sticky quote bar (mobile).
 *
 * Shown once the page's first section has scrolled out of view, and hidden again while
 * the section it links to (data-target) is on screen, so it never sits over the hero
 * buttons or the form itself.
 */
if (!customElements.get('sticky-quote-bar')) {
  customElements.define(
    'sticky-quote-bar',
    class StickyQuoteBar extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        this.firstSection = document.querySelector('#MainContent > .shopify-section');
        if (!this.target || !this.firstSection || !('IntersectionObserver' in window)) return;

        this.pastFirstSection = false;
        this.targetVisible = false;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.firstSection) {
              // Only count it as passed once it has left through the top of the screen.
              this.pastFirstSection = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            } else {
              this.targetVisible = entry.isIntersecting;
            }
          });
          this.update();
        });

        this.observer.observe(this.firstSection);
        this.observer.observe(this.target);

        this.classList.add('is-hidden');
        this.hidden = false;
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      update() {
        const show = this.pastFirstSection && !this.targetVisible;
        this.classList.toggle('is-hidden', !show);
        this.toggleAttribute('inert', !show);
      }
    }
  );
}
